import { http } from '@/utils/http';

//房间数据
export const getData = async function(url = '', params = {}, method = "GET") {
  const { data, status } = await http(url, params, method);
  return data
}

//课程日志
export const setCourseLog = async function(url = '', params = {}, method = "GET") {
  const { data, status } = await http(url, params, method);
  return data
}

//提交评价
export const submitEvaluate = async function(url = '', params = {}, method = "GET") {
  const { data, status } = await http(url, params, method);
  return data
}

//添加题目
export const addQuestion = async function(url = '', params = {}, method = "GET") {
  const { data, status } = await http(url, params, method);
  return data
}

//提交问题
export const submitQuestion = async function(url = '', params = {}, method = "GET") {
  const { data, status } = await http(url, params, method);
  return data
}

//统计问题数据
export const statQuestion = async function(url = '', params = {}, method = "GET") {
  const { data, status } = await http(url, params, method);
  return data
}

//获取作业
export const getSeriesPaper = async function(url = '', params = {}, method = "GET") {
  const { data, status } = await http(url, params, method);
  return data
}

//获取作业
export const sumbitSeriesPaper = async function(url = '', params = {}, method = "POST") {
  const { data, status } = await http(url, params, method);
  return data
}



// WEBPACK FOOTER //
// ./src/server/videoRoom.js